export const config = {
  firebaseConfig: {
    apiKey: 'AIzaSyBm2zD4uflSsygLCRPi-KfrxJz4Vm8odGM',
    authDomain: 'kindergarten-timetracker.firebaseapp.com',
    databaseURL: 'https://kindergarten-timetracker-default-rtdb.firebaseio.com',
    projectId: 'kindergarten-timetracker',
    storageBucket: 'kindergarten-timetracker.appspot.com',
    messagingSenderId: '1000745214917',
    appId: '1:1000745214917:web:51e6900d258f391b78a1ac',
    measurementId: 'G-4B9CJPZN8T',
  },
  contact: {
    name: 'Florian Jud',
    email: 'kindergarten.timetracker@gmail.com',
    street: 'Oberer Eulenbergweg 41',
    city: '73776 Altbach',
  },
};

